/* eslint-disable camelcase */
import 'whatwg-fetch';
import {notifyFetchErrors} from 'utilities/fetch';
import getCSRFToken from 'utilities/security/token-fetcher';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': getCSRFToken(),
};

const options = {
  headers,
  credentials: 'same-origin',
  method: 'GET',
};

export function getReviewMetrics({organizationId, serviceHandle}) {
  const BASE_URL = `/services_marketplace/organizations/${organizationId}/reviews/metrics`;
  const URL = serviceHandle
    ? `${BASE_URL}?service_handle=${serviceHandle}`
    : BASE_URL;

  return fetch(URL, options)
    .then(
      notifyFetchErrors('ServicesMarketplace::GetReviewMetricsRejected', {
        organizationId,
      })
    )
    .then(response => response.json());
}
